import { render, staticRenderFns } from "./callio.vue?vue&type=template&id=4cd9f8b6&scoped=true"
import script from "./callio.vue?vue&type=script&lang=js"
export * from "./callio.vue?vue&type=script&lang=js"
import style0 from "./callio.vue?vue&type=style&index=0&id=4cd9f8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9f8b6",
  null
  
)

export default component.exports